import React from "react";
import { Table, TableBody, TableContainer } from "@mui/material";
import { WebhooksTableHead } from "./WebhooksTableHead";
import { WebhookRow } from "./WebhookRow";

export const WebhooksTable = ({
    webhooks = [],
    refetch,
    sortConfig,
    onSortChange
}) => {
    return (
        <TableContainer sx={{ minWidth: "1000px" }}>
            <Table>
                <WebhooksTableHead
                    sortConfig={sortConfig}
                    onSortChange={onSortChange}
                />
                <TableBody>
                    {webhooks.map((webhook) => (
                        <WebhookRow
                            key={webhook.id}
                            webhook={webhook}
                            refetch={refetch}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
